import BmrRoles from "./roles";
import OnBoardUser from "./onBoardUser";
import Feasibility from "./feasibility";
import SlotManagement from "./slotManagement";
import QRCode from "./QRCode";
import BmrAppointment from "./appointment";
import BmrLocation from "./location";
import BmrCommon from "./common";
import BmrQueryPreScreen from "./queryPreScreen";
import BmrApheresis from "./apheresis";
import BmrHelp from "./help";
import BmrFormTemplate from "./formTemplate";
import BmrInBound from "./inbound";
import BmrQueryInbound from "./inbound";
import BmrLogistic from './logisticSlice'
import BmrChat from './chat'
import BmrFbPermission from '../../lib/form-builder/slices/FbPermission';
import bmrFbPropertyReducer from "../../lib/form-builder/slices/FbProperty"
import bmrFbShadowSlice from "../../lib/form-builder/slices/FbShadowForm"
import BmrFbSections from '../../lib/form-builder/slices/FbSections';
import BmrPrintDetails from "./printDetails";
import BmrLsmRejectionReason from "./lsmRejectionReason"
import BmrManufacturing from "./manufacturer"
import QualityControlList from "./qualityControl"
import programCodeSlice from './program'
import QualityApprovalList from "./qualityApproval";
import Outbound from "./outbound"
import BmrLeukapheresisConditions from "./leukapheresisCondition"
import  BmrProductCalculation from './productCalculations'
import BmrLSMAcceptanceReasons from "./lsmAcceptanceReason"
import BmrRemanufacturingReasons from "./remanufacturingReasons"
import bmrCutomMaster from './customMaster'
import BmrStorageLocation from "./storageLocation"
import BmrDeliveryPartners from "./deliveryPartners"
import CartForm from "./carTForm"
import EmailTemplatesSlice from "./emailTemplates"
import AssignedTemplatesSlice from "../../lib/form-assigned/slice/FbAssignedPermission"
import DisclaimerSlice from"./disclaimer"
import BmrStateSlice from "./state"
import BmrCountrySlice from "./country"
import BmrCitySlice from "./city"
import BmrfbMasterSlice from "./formbuildermaster"
const bmrSliceGroup = {
  bmrRoles: BmrRoles,
  onBoardUser: OnBoardUser,
  feasibility: Feasibility,
  slotManagement: SlotManagement,
  qrCode: QRCode,
  bmrAppointment: BmrAppointment,
  bmrInBound: BmrInBound,
  bmrLocation: BmrLocation,
  bmrCommon: BmrCommon,
  bmrQueryPreScreen: BmrQueryPreScreen,
  bmrQueryInbound: BmrQueryInbound,
  bmrApheresis: BmrApheresis,
  bmrHelp: BmrHelp,
  bmrFbl: BmrFormTemplate,
  bmrLogistic: BmrLogistic,
  bmrChat: BmrChat,
  bmrLsmRejectionReason: BmrLsmRejectionReason,
  bmrManufacturing: BmrManufacturing,
  qualityControlList: QualityControlList,
  programCodeSlice:programCodeSlice,
  qualityApprovalList: QualityApprovalList,
  outbound: Outbound,
  bmrLeukapheresisConditions: BmrLeukapheresisConditions,
  BmrProductCalculation: BmrProductCalculation,
  bmrLSMAcceptanceReasons: BmrLSMAcceptanceReasons,
  bmrRemanufacturingReasons: BmrRemanufacturingReasons,
  bmrStorageLocation: BmrStorageLocation,
  bmrDeliveryPartners: BmrDeliveryPartners,
  cartForm: CartForm,
  bmrFbPermission: BmrFbPermission,
  bmrFbProperty : bmrFbPropertyReducer, 
  bmrFbShadow: bmrFbShadowSlice,
  bmrFbSections: BmrFbSections,
  bmrPrintDetails:BmrPrintDetails,
  bmrCutomMaster:bmrCutomMaster,
  emailTemplates:EmailTemplatesSlice,
  assignedTemplates: AssignedTemplatesSlice,
  disclaimer:DisclaimerSlice,
  bmrCity:BmrCitySlice,
  bmrState:BmrStateSlice,
  bmrCountry:BmrCountrySlice,
  bmrFormBuilderMaster:BmrfbMasterSlice,
};
export default bmrSliceGroup;
